import { ReactComponent as AccountBalance } from "@material-symbols/svg-400/rounded/account_balance.svg";
import { ReactComponent as AccountCircle } from "@material-symbols/svg-400/rounded/account_circle.svg";
import { ReactComponent as Add } from "@material-symbols/svg-400/rounded/add.svg";
import { ReactComponent as Apartment } from "@material-symbols/svg-400/rounded/apartment.svg";
import { ReactComponent as Apps } from "@material-symbols/svg-400/rounded/apps.svg";
import { ReactComponent as ArrowDownward } from "@material-symbols/svg-400/rounded/arrow_downward.svg";
import { ReactComponent as ArrowForward } from "@material-symbols/svg-400/rounded/arrow_forward.svg";
import { ReactComponent as ArrowOutward } from "@material-symbols/svg-400/rounded/arrow_outward.svg";
import { ReactComponent as ArrowRange } from "@material-symbols/svg-400/rounded/arrow_range.svg";
import { ReactComponent as ArrowUpward } from "@material-symbols/svg-400/rounded/arrow_upward.svg";
import { ReactComponent as ArticlePerson } from "@material-symbols/svg-400/rounded/article_person.svg";
import { ReactComponent as Assignment } from "@material-symbols/svg-400/rounded/assignment.svg";
import { ReactComponent as AssignmentTurnedIn } from "@material-symbols/svg-400/rounded/assignment_turned_in.svg";
import { ReactComponent as AttachFile } from "@material-symbols/svg-400/rounded/attach_file.svg";
import { ReactComponent as AttachMoney } from "@material-symbols/svg-400/rounded/attach_money.svg";
import { ReactComponent as AwardStar } from "@material-symbols/svg-400/rounded/award_star.svg";
import { ReactComponent as BarChart } from "@material-symbols/svg-400/rounded/bar_chart.svg";
import { ReactComponent as Block } from "@material-symbols/svg-400/rounded/block.svg";
import { ReactComponent as BusinessCenterFilled } from "@material-symbols/svg-400/rounded/business_center-fill.svg";
import { ReactComponent as BusinessCenter } from "@material-symbols/svg-400/rounded/business_center.svg";
import { ReactComponent as CalendarToday } from "@material-symbols/svg-400/rounded/calendar_today.svg";
import { ReactComponent as Call } from "@material-symbols/svg-400/rounded/call.svg";
import { ReactComponent as CallEndFilled } from "@material-symbols/svg-400/rounded/call_end-fill.svg";
import { ReactComponent as CancelFilled } from "@material-symbols/svg-400/rounded/cancel-fill.svg";
import { ReactComponent as Cancel } from "@material-symbols/svg-400/rounded/cancel.svg";
import { ReactComponent as ChartData } from "@material-symbols/svg-400/rounded/chart_data.svg";
import { ReactComponent as ChatBubble } from "@material-symbols/svg-400/rounded/chat_bubble.svg";
import { ReactComponent as Check } from "@material-symbols/svg-400/rounded/check.svg";
import { ReactComponent as CheckCircleFilled } from "@material-symbols/svg-400/rounded/check_circle-fill.svg";
import { ReactComponent as CheckCircle } from "@material-symbols/svg-400/rounded/check_circle.svg";
import { ReactComponent as Checklist } from "@material-symbols/svg-400/rounded/checklist.svg";
import { ReactComponent as ChevronLeft } from "@material-symbols/svg-400/rounded/chevron_left.svg";
import { ReactComponent as ChevronRight } from "@material-symbols/svg-400/rounded/chevron_right.svg";
import { ReactComponent as Circle } from "@material-symbols/svg-400/rounded/circle.svg";
import { ReactComponent as ClinicalNotes } from "@material-symbols/svg-400/rounded/clinical_notes.svg";
import { ReactComponent as Close } from "@material-symbols/svg-400/rounded/close.svg";
import { ReactComponent as ContactEmergency } from "@material-symbols/svg-400/rounded/contact_emergency.svg";
import { ReactComponent as Copy } from "@material-symbols/svg-400/rounded/content_copy.svg";
import { ReactComponent as CreateNewFolder } from "@material-symbols/svg-400/rounded/create_new_folder.svg";
import { ReactComponent as Delete } from "@material-symbols/svg-400/rounded/delete.svg";
import { ReactComponent as Description } from "@material-symbols/svg-400/rounded/description.svg";
import { ReactComponent as DockToRight } from "@material-symbols/svg-400/rounded/dock_to_right.svg";
import { ReactComponent as DomainFilled } from "@material-symbols/svg-400/rounded/domain-fill.svg";
import { ReactComponent as Domain } from "@material-symbols/svg-400/rounded/domain.svg";
import { ReactComponent as FileDownload } from "@material-symbols/svg-400/rounded/download.svg";
import { ReactComponent as DragHandle } from "@material-symbols/svg-400/rounded/drag_handle.svg";
import { ReactComponent as Edit } from "@material-symbols/svg-400/rounded/edit.svg";
import { ReactComponent as ElectricBolt } from "@material-symbols/svg-400/rounded/electric_bolt.svg";
import { ReactComponent as Equal } from "@material-symbols/svg-400/rounded/equal.svg";
import { ReactComponent as ErrorFillIcon } from "@material-symbols/svg-400/rounded/error-fill.svg";
import { ReactComponent as ErrorIcon } from "@material-symbols/svg-400/rounded/error.svg";
import { ReactComponent as Face } from "@material-symbols/svg-400/rounded/face.svg";
import { ReactComponent as Factory } from "@material-symbols/svg-400/rounded/factory.svg";
import { ReactComponent as Feedback } from "@material-symbols/svg-400/rounded/feedback.svg";
import { ReactComponent as Filter } from "@material-symbols/svg-400/rounded/filter_alt.svg";
import { ReactComponent as FinanceChip } from "@material-symbols/svg-400/rounded/finance_chip.svg";
import { ReactComponent as Flag } from "@material-symbols/svg-400/rounded/flag.svg";
import { ReactComponent as Folder } from "@material-symbols/svg-400/rounded/folder.svg";
import { ReactComponent as FormatListNumbered } from "@material-symbols/svg-400/rounded/format_list_numbered.svg";
import { ReactComponent as FormatQuote } from "@material-symbols/svg-400/rounded/format_quote.svg";
import { ReactComponent as Forum } from "@material-symbols/svg-400/rounded/forum.svg";
import { ReactComponent as GppMaybe } from "@material-symbols/svg-400/rounded/gpp_maybe.svg";
import { ReactComponent as GridOn } from "@material-symbols/svg-400/rounded/grid_on.svg";
import { ReactComponent as GridView } from "@material-symbols/svg-400/rounded/grid_view.svg";
import { ReactComponent as Group } from "@material-symbols/svg-400/rounded/group.svg";
import { ReactComponent as GroupAdd } from "@material-symbols/svg-400/rounded/group_add.svg";
import { ReactComponent as GroupSearch } from "@material-symbols/svg-400/rounded/group_search.svg";
import { ReactComponent as Groups } from "@material-symbols/svg-400/rounded/groups.svg";
import { ReactComponent as Handshake } from "@material-symbols/svg-400/rounded/handshake.svg";
import { ReactComponent as Help } from "@material-symbols/svg-400/rounded/help.svg";
import { ReactComponent as History } from "@material-symbols/svg-400/rounded/history.svg";
import { ReactComponent as Info } from "@material-symbols/svg-400/rounded/info.svg";
import { ReactComponent as ListAltCheck } from "@material-symbols/svg-400/rounded/list_alt_check.svg";
import { ReactComponent as Merge } from "@material-symbols/svg-400/rounded/merge.svg";
import { ReactComponent as Payments } from "@material-symbols/svg-400/rounded/payments.svg";
import { ReactComponent as PhoneInTalk } from "@material-symbols/svg-400/rounded/phone_in_talk.svg";
import { ReactComponent as StarHalf } from "@material-symbols/svg-400/rounded/star_half.svg";
import { ReactComponent as Tune } from "@material-symbols/svg-400/rounded/tune.svg";
import { ReactComponent as Drafts } from "@material-symbols/svg-400/sharp/drafts.svg";
import { ReactComponent as ForwardToInbox } from "@material-symbols/svg-400/sharp/forward_to_inbox.svg";
import { ReactComponent as HourGlassTop } from "@material-symbols/svg-400/sharp/hourglass_top.svg";
import {
  ReactComponent as ArrowDown,
  ReactComponent as KeyboardArrowDown
} from "@material-symbols/svg-400/sharp/keyboard_arrow_down.svg";
import { ReactComponent as ArrowUp } from "@material-symbols/svg-400/sharp/keyboard_arrow_up.svg";
import { ReactComponent as Lightbulb } from "@material-symbols/svg-400/sharp/lightbulb.svg";
import { ReactComponent as Link } from "@material-symbols/svg-400/sharp/link.svg";
import { ReactComponent as LocationSearching } from "@material-symbols/svg-400/sharp/location_searching.svg";
import { ReactComponent as Logout } from "@material-symbols/svg-400/sharp/logout.svg";
import { ReactComponent as Mail } from "@material-symbols/svg-400/sharp/mail.svg";
import { ReactComponent as ManageAccounts } from "@material-symbols/svg-400/sharp/manage_accounts.svg";
import { ReactComponent as ManageSearch } from "@material-symbols/svg-400/sharp/manage_search.svg";
import { ReactComponent as Menu } from "@material-symbols/svg-400/sharp/menu.svg";
import { ReactComponent as Mic } from "@material-symbols/svg-400/sharp/mic-fill.svg";
import { ReactComponent as MicOff } from "@material-symbols/svg-400/sharp/mic_off-fill.svg";
import { ReactComponent as ThreeDotsHorizontal } from "@material-symbols/svg-400/sharp/more_horiz.svg";
import { ReactComponent as MyLocation } from "@material-symbols/svg-400/sharp/my_location.svg";
import { ReactComponent as Notes } from "@material-symbols/svg-400/sharp/notes.svg";
import { ReactComponent as NotificationAdd } from "@material-symbols/svg-400/sharp/notification_add.svg";
import { ReactComponent as Paid } from "@material-symbols/svg-400/sharp/paid.svg";
import { ReactComponent as Password } from "@material-symbols/svg-400/sharp/password.svg";
import { ReactComponent as Person } from "@material-symbols/svg-400/sharp/person.svg";
import { ReactComponent as PersonAdd } from "@material-symbols/svg-400/sharp/person_add.svg";
import { ReactComponent as PhoneDisabled } from "@material-symbols/svg-400/sharp/phone_disabled.svg";
import { ReactComponent as PhoneForwardedFilled } from "@material-symbols/svg-400/sharp/phone_forwarded-fill.svg";
import { ReactComponent as PDF } from "@material-symbols/svg-400/sharp/picture_as_pdf.svg";
import { ReactComponent as Public } from "@material-symbols/svg-400/sharp/public.svg";
import { ReactComponent as Stats } from "@material-symbols/svg-400/sharp/query_stats.svg";
import { ReactComponent as Radar } from "@material-symbols/svg-400/sharp/radar.svg";
import { ReactComponent as RadioButtonChecked } from "@material-symbols/svg-400/sharp/radio_button_checked.svg";
import { ReactComponent as RateReview } from "@material-symbols/svg-400/sharp/rate_review.svg";
import { ReactComponent as ReceiptLong } from "@material-symbols/svg-400/sharp/receipt_long.svg";
import { ReactComponent as Refresh } from "@material-symbols/svg-400/sharp/refresh.svg";
import { ReactComponent as Repeat } from "@material-symbols/svg-400/sharp/repeat.svg";
import { ReactComponent as Schedule } from "@material-symbols/svg-400/sharp/schedule.svg";
import { ReactComponent as ScreenShare } from "@material-symbols/svg-400/sharp/screen_share.svg";
import { ReactComponent as Search } from "@material-symbols/svg-400/sharp/search.svg";
import { ReactComponent as Send } from "@material-symbols/svg-400/sharp/send.svg";
import { ReactComponent as Settings } from "@material-symbols/svg-400/sharp/settings.svg";
import { ReactComponent as Share } from "@material-symbols/svg-400/sharp/share.svg";
import { ReactComponent as SignalCellularAlt } from "@material-symbols/svg-400/sharp/signal_cellular_alt.svg";
import { ReactComponent as SmartToy } from "@material-symbols/svg-400/sharp/smart_toy.svg";
import { ReactComponent as SMS } from "@material-symbols/svg-400/sharp/sms.svg";
import { ReactComponent as Star } from "@material-symbols/svg-400/sharp/star.svg";
import { ReactComponent as StickyNote2 } from "@material-symbols/svg-400/sharp/sticky_note_2.svg";
import { ReactComponent as StopScreenShare } from "@material-symbols/svg-400/sharp/stop_screen_share.svg";
import { ReactComponent as Sync } from "@material-symbols/svg-400/sharp/sync.svg";
import { ReactComponent as TableEye } from "@material-symbols/svg-400/sharp/table_eye.svg";
import { ReactComponent as Target } from "@material-symbols/svg-400/sharp/target.svg";
import { ReactComponent as ThumbDown } from "@material-symbols/svg-400/sharp/thumb_down.svg";
import { ReactComponent as ThumbUp } from "@material-symbols/svg-400/sharp/thumb_up.svg";
import { ReactComponent as Timeline } from "@material-symbols/svg-400/sharp/timeline.svg";
import { ReactComponent as TrendingDown } from "@material-symbols/svg-400/sharp/trending_down.svg";
import { ReactComponent as TrendingUp } from "@material-symbols/svg-400/sharp/trending_up.svg";
import { ReactComponent as TripOrigin } from "@material-symbols/svg-400/sharp/trip_origin.svg";
import { ReactComponent as Undo } from "@material-symbols/svg-400/sharp/undo.svg";
import { ReactComponent as UnfoldLess } from "@material-symbols/svg-400/sharp/unfold_less.svg";
import { ReactComponent as UnfoldMore } from "@material-symbols/svg-400/sharp/unfold_more.svg";
import { ReactComponent as Upload } from "@material-symbols/svg-400/sharp/upload.svg";
import { ReactComponent as Verified } from "@material-symbols/svg-400/sharp/verified.svg";
import { ReactComponent as VerifiedUser } from "@material-symbols/svg-400/sharp/verified_user.svg";
import { ReactComponent as VideoCameraFront } from "@material-symbols/svg-400/sharp/video_camera_front.svg";
import { ReactComponent as VideoCam } from "@material-symbols/svg-400/sharp/videocam.svg";
import { ReactComponent as VideoCamOff } from "@material-symbols/svg-400/sharp/videocam_off.svg";
import { ReactComponent as Visibility } from "@material-symbols/svg-400/sharp/visibility.svg";
import { ReactComponent as VisibilityOff } from "@material-symbols/svg-400/sharp/visibility_off.svg";
import { ReactComponent as VpnKey } from "@material-symbols/svg-400/sharp/vpn_key.svg";
import { ReactComponent as WandStars } from "@material-symbols/svg-400/sharp/wand_stars.svg";
import { ReactComponent as Warning } from "@material-symbols/svg-400/sharp/warning.svg";
import { ReactComponent as Work } from "@material-symbols/svg-400/sharp/work.svg";
import { ReactComponent as Workspaces } from "@material-symbols/svg-400/sharp/workspaces.svg";
import { ReactComponent as ZoomInMap } from "@material-symbols/svg-400/sharp/zoom_in_map.svg";

// IconName, non-filled icons. IconFillName, filled Icons. Remember to import the correct version

export type IconName =
  | "account_balance"
  | "add"
  | "apartment"
  | "apps"
  | "article_person"
  | "arrowDown"
  | "arrowDownward"
  | "arrowOutward"
  | "arrowRange"
  | "arrowUp"
  | "assignment"
  | "attach_file"
  | "attach_money"
  | "business_center"
  | "business_center_filled"
  | "calendar_today"
  | "call"
  | "call_end_filled"
  | "cancel"
  | "cancel_filled"
  | "chat_bubble"
  | "chart_data"
  | "check"
  | "check_circle"
  | "check_circle_filled"
  | "chevronLeft"
  | "chevronRight"
  | "circle"
  | "close"
  | "copy"
  | "delete"
  | "description"
  | "dock_to_right"
  | "domain"
  | "domain_filled"
  | "drag_handle"
  | "edit"
  | "equal"
  | "error"
  | "error_filled"
  | "sync"
  | "face"
  | "file_download"
  | "flag"
  | "folder"
  | "create_new_folder"
  | "forum"
  | "forward_to_inbox"
  | "format_list_numbered"
  | "format_quote"
  | "gpp_maybe"
  | "group"
  | "group_add"
  | "groups"
  | "handshake"
  | "help"
  | "info"
  | "keyboard_arrow_down"
  | "link"
  | "logout"
  | "drafts"
  | "mail"
  | "manage_accounts"
  | "manage_search"
  | "menu"
  | "merge"
  | "mic"
  | "mic_off"
  | "more_horiz"
  | "notes"
  | "password"
  | "paid"
  | "payments"
  | "person"
  | "phone_in_talk"
  | "phone_disabled"
  | "phone_forwarded_filled"
  | "picture_as_pdf"
  | "radioButtonChecked"
  | "rate_review"
  | "receipt_long"
  | "repeat"
  | "schedule"
  | "screen_share"
  | "search"
  | "send"
  | "settings"
  | "stats"
  | "stop_screen_share"
  | "undo"
  | "verified_user"
  | "videocam"
  | "videocam_off"
  | "video_camera_front"
  | "visibility"
  | "visibility_off"
  | "wand_stars"
  | "warning"
  | "workspaces"
  | "zoom_in_map"
  | "table_eye"
  | "feedback"
  | "factory"
  | "contact_emergency"
  | "award_star"
  | "upload"
  | "block"
  | "public"
  | "filter_alt"
  | "star"
  | "star_half"
  | "smart_toy"
  | "trip_origin"
  | "unfold_less"
  | "unfold_more"
  | "share"
  | "work"
  | "lightbulb"
  | "bar_chart"
  | "grid_on"
  | "grid_view"
  | "target"
  | "signal_cellular_alt"
  | "refresh"
  | "electric_bolt"
  | "timeline"
  | "trending_up"
  | "trending_down"
  | "arrow_upward"
  | "my_location"
  | "notification_add"
  | "checklist"
  | "sms"
  | "sticky_note_2"
  | "location_searching"
  | "radar"
  | "person_add"
  | "assignment_turned_in"
  | "account_circle"
  | "thumb_up"
  | "thumb_down"
  | "group_search"
  | "verified"
  | "vpn_key"
  | "finance_chip"
  | "arrow_forward"
  | "list_alt_check"
  | "tune"
  | "hourglass_top"
  | "clinical_notes"
  | "history";

export const icons: Record<
  IconName,
  React.FunctionComponent<React.SVGProps<SVGSVGElement>>
> = {
  account_balance: AccountBalance,
  add: Add,
  apartment: Apartment,
  apps: Apps,
  article_person: ArticlePerson,
  arrowDown: ArrowDown,
  arrowDownward: ArrowDownward,
  arrowOutward: ArrowOutward,
  arrowRange: ArrowRange,
  arrowUp: ArrowUp,
  assignment: Assignment,
  attach_file: AttachFile,
  attach_money: AttachMoney,
  business_center: BusinessCenter,
  business_center_filled: BusinessCenterFilled,
  calendar_today: CalendarToday,
  call: Call,
  call_end_filled: CallEndFilled,
  cancel: Cancel,
  cancel_filled: CancelFilled,
  chat_bubble: ChatBubble,
  clinical_notes: ClinicalNotes,
  chart_data: ChartData,
  check: Check,
  check_circle: CheckCircle,
  check_circle_filled: CheckCircleFilled,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  circle: Circle,
  close: Close,
  copy: Copy,
  delete: Delete,
  description: Description,
  dock_to_right: DockToRight,
  domain: Domain,
  domain_filled: DomainFilled,
  drag_handle: DragHandle,
  edit: Edit,
  equal: Equal,
  error: ErrorIcon,
  error_filled: ErrorFillIcon,
  sync: Sync,
  face: Face,
  file_download: FileDownload,
  flag: Flag,
  folder: Folder,
  create_new_folder: CreateNewFolder,
  forum: Forum,
  forward_to_inbox: ForwardToInbox,
  format_list_numbered: FormatListNumbered,
  format_quote: FormatQuote,
  gpp_maybe: GppMaybe,
  group: Group,
  group_add: GroupAdd,
  groups: Groups,
  handshake: Handshake,
  help: Help,
  info: Info,
  keyboard_arrow_down: KeyboardArrowDown,
  link: Link,
  logout: Logout,
  drafts: Drafts,
  mail: Mail,
  manage_accounts: ManageAccounts,
  manage_search: ManageSearch,
  menu: Menu,
  merge: Merge,
  mic: Mic,
  mic_off: MicOff,
  more_horiz: ThreeDotsHorizontal,
  notes: Notes,
  password: Password,
  paid: Paid,
  payments: Payments,
  person: Person,
  phone_in_talk: PhoneInTalk,
  phone_disabled: PhoneDisabled,
  phone_forwarded_filled: PhoneForwardedFilled,
  picture_as_pdf: PDF,
  radioButtonChecked: RadioButtonChecked,
  rate_review: RateReview,
  receipt_long: ReceiptLong,
  repeat: Repeat,
  schedule: Schedule,
  screen_share: ScreenShare,
  search: Search,
  send: Send,
  settings: Settings,
  stats: Stats,
  star: Star,
  star_half: StarHalf,
  stop_screen_share: StopScreenShare,
  undo: Undo,
  verified_user: VerifiedUser,
  videocam: VideoCam,
  videocam_off: VideoCamOff,
  video_camera_front: VideoCameraFront,
  visibility: Visibility,
  visibility_off: VisibilityOff,
  warning: Warning,
  workspaces: Workspaces,
  zoom_in_map: ZoomInMap,
  table_eye: TableEye,
  factory: Factory,
  feedback: Feedback,
  contact_emergency: ContactEmergency,
  award_star: AwardStar,
  wand_stars: WandStars,
  block: Block,
  history: History,
  upload: Upload,
  public: Public,
  filter_alt: Filter,
  smart_toy: SmartToy,
  trip_origin: TripOrigin,
  unfold_less: UnfoldLess,
  unfold_more: UnfoldMore,
  share: Share,
  work: Work,
  lightbulb: Lightbulb,
  bar_chart: BarChart,
  grid_on: GridOn,
  grid_view: GridView,
  target: Target,
  signal_cellular_alt: SignalCellularAlt,
  refresh: Refresh,
  electric_bolt: ElectricBolt,
  timeline: Timeline,
  trending_up: TrendingUp,
  trending_down: TrendingDown,
  arrow_upward: ArrowUpward,
  my_location: MyLocation,
  notification_add: NotificationAdd,
  checklist: Checklist,
  sms: SMS,
  sticky_note_2: StickyNote2,
  location_searching: LocationSearching,
  radar: Radar,
  person_add: PersonAdd,
  assignment_turned_in: AssignmentTurnedIn,
  account_circle: AccountCircle,
  thumb_up: ThumbUp,
  thumb_down: ThumbDown,
  group_search: GroupSearch,
  verified: Verified,
  vpn_key: VpnKey,
  finance_chip: FinanceChip,
  arrow_forward: ArrowForward,
  list_alt_check: ListAltCheck,
  tune: Tune,
  hourglass_top: HourGlassTop
};
